var map = {
	"./blackGold/footer/vault.png": 25691,
	"./brownGold/footer/vault.png": 840,
	"./darkBlue/footer/vault.png": 87601,
	"./greenYellow/footer/vault.png": 81881,
	"./redGold/footer/vault.png": 89386,
	"./skyBlue/footer/vault.png": 34656,
	"./whiteGold/footer/vault.png": 7977,
	"./yellowWhite/footer/vault.png": 19994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24106;